<template>
    <div class="formulate-vfile">
        <FileUploader class="button button_green button_small" v-model="localFiles">Загрузить файл</FileUploader>
        <FileViewer upload v-model="localFiles" class="formulate-vfile__viewer"></FileViewer>
    </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FileViewer from '@/views/components/FileViewer';
import FileUploader from '@/views/components/FileUploader';

/**
 * Vue Formulate custom input (`vfile` type) that reuses the app's upload widget. The model exposed to
 * Formulate is the list of uploaded file ids, which is exactly what the create-request endpoint
 * expects for a FILE form field.
 */
@Component({ components: { FileViewer, FileUploader } })
class FormulateVFile extends Vue {
    @Prop({ type: Object, required: true }) context;

    localFiles = [];
    emittedIds = '';

    /**
     * Deep, because FileUploader hands over its file object while the upload is still in flight
     * (id === -1) and writes the real id into that same object once the POST resolves. A shallow
     * watcher never sees that mutation, so the form would submit an empty file list.
     */
    @Watch('localFiles', { deep: true })
    onFilesChange(files) {
        const ids = (files || []).filter((file) => file.id && file.id !== -1).map((file) => file.id);
        const signature = ids.join(',');

        // The deep watcher also fires on every upload-progress tick; only a changed id list is news.
        if (signature === this.emittedIds) {
            return;
        }

        this.emittedIds = signature;
        this.context.model = ids;
    }
}

export default FormulateVFile;
</script>
<style lang="scss">
.formulate-vfile {
    &__viewer {
        margin-top: 8px;
        max-height: 250px;
        overflow-y: auto;
    }

    .button {
        width: auto;
    }
}
</style>
